export default __webpack_public_path__ + "static/media/pton-thesis.c8d6158b.pdf";